// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15bdb451","239":"01e882df","455":"fb9fe8b3"}[chunkId] + ".chunk.js";
};